export const PHARMACIES_SAVE = "PHARMACIES_SAVE";
export const pharmacies_save = (payload) => ({
  type: PHARMACIES_SAVE,
  payload,
});
